import React, { useEffect, useState } from 'react';
import FormField from 'components/Form/FormField';
import UserSelectDropdown from 'components/DropdownSelect/MultiSelectDropdown/Usage/UsersMultiSelectDropdown';
import TagsMultiSelectDropdown from 'components/DropdownSelect/MultiSelectDropdown/Usage/TagsMultiSelectDropdown';
import AnyStringSingleSelectDropdown from 'components/DropdownSelect/SingleSelectDropdown/Usage/AnyStringSingleSelectDropdown';
import Filters from 'components/Filters/Filters';
import { CampaignsFilterInterface, useCampaignsContext } from 'pages/Campaigns/campaigns.context';
import StoresMultiSelectDropdown from 'components/DropdownSelect/MultiSelectDropdown/Usage/StoresMultiSelectDropdown';

const CampaignFilters = () => {
  const { campaignsFilter, setCampaignsFilter } = useCampaignsContext();
  const [filters, setFilters] = useState(campaignsFilter);

  useEffect(() => {
    setFilters(campaignsFilter);
  }, [campaignsFilter]);

  const handleChangeField = (
    value: string | number | number[] | undefined,
    key: keyof CampaignsFilterInterface
  ) => {
    if (Array.isArray(value) && !value.length) {
      setFilters({ ...filters, [key]: [] });
    } else {
      setFilters({ ...filters, [key]: value });
    }
  };

  const clearFilters = () =>
    setCampaignsFilter({ tenantId: campaignsFilter.tenantId, userId: campaignsFilter.userId });

  const filterInputs = [
    <FormField
      field={{
        label: 'Filter by name',
        value: filters.name,
        containedLabel: true,
        onChange: () => {},
        fieldProps: {
          size: 'small',
        },
      }}
      onChange={(name) => handleChangeField(name, 'name')}
      key='name'
    />,
    <UserSelectDropdown
      selectedUserIds={filters.userIds}
      containedLabel={true}
      onChange={(newUsers) =>
        handleChangeField(
          newUsers.map((user) => user.id!),
          'userIds'
        )
      }
      key='users'
      inputProps={{ size: 'small' }}
    />,
    <FormField
      field={{
        label: 'Start Date',
        value: filters.startDate,
        type: 'date',
        containedLabel: true,
        onChange: () => {},
        fieldProps: {
          size: 'small',
        },
      }}
      onChange={(startDate) => handleChangeField(startDate, 'startDate')}
      key='startDate'
    />,
    <AnyStringSingleSelectDropdown
      onChange={(state) => handleChangeField(state?.name, 'status')}
      strings={['Ended', 'Active']}
      selectedString={filters.status}
      key='status'
      containedLabel={true}
      inputProps={{ size: 'small' }}
    />,
    <TagsMultiSelectDropdown
      selectedTagIds={filters.tagIds}
      containedLabel={true}
      onChange={(tags) =>
        handleChangeField(
          tags.map((tag) => tag.id!),
          'tagIds'
        )
      }
      key='tags'
      inputProps={{ size: 'small' }}
    />,
    <StoresMultiSelectDropdown
      selectedStoreIds={filters.storeIds}
      containedLabel={true}
      key='Stores'
      onChange={(stores) =>
        handleChangeField(
          stores.map((store) => store.id!),
          'storeIds'
        )
      }
      inputProps={{ size: 'small' }}
    />,
  ];

  const hasFilters = !!Object.entries(filters).find(
    (filter) => filter[0] !== 'tenantId' && (filter[1]?.length || filter[1] > 0)
  );

  return (
    <Filters
      filterInputs={filterInputs}
      onApplyFilters={() => setCampaignsFilter(filters)}
      onClearFilters={clearFilters}
      hasFilters={hasFilters}
    />
  );
};

export default CampaignFilters;
